function normalizeProfile(profile = {}) {
    const result = { ...profile };

    // данные в customData могут быть только строками
    if (result.customData && typeof result.customData === 'object') {
        result.customData = Object.fromEntries(
            Object.entries(result.customData)
                .filter(([key, value]) => key && value != null && value !== '')
                .map(([key, value]) => [key, String(value)])
        );
    }

    return result;
}

export function setProfile(profile = {}) {
    (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
        try {
            const data = normalizeProfile(profile);
            const userId = data.userId || window.tourist_auth?.id;

            if (userId && userId > 0) {
                rrApi.setCustomer({
                    ...data,
                    customerId: `lk-user${userId}`,
                });
            } else {
                rrApi.setProfile(data);
            }
        } catch (e) {
            console.error(e);
        }
    });
}

export function welcomeSequence(email) {
    (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
        try {
            rrApi.welcomeSequence(email);
        } catch (e) {
            console.error(e);
        }
    });
}

/** Welcome-цепочка после подтверждения подписки (подвал, баннер главной, баннер блога). */
export function welcomeSequenceV2() {
    (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
        try {
            rrApi.welcomeSequenceV2();
        } catch (e) {
            console.error(e);
        }
    });
}

export function order(orderData) {
    (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
        try {
            rrApi.order(orderData);
        } catch (e) {
            console.error(e);
        }
    });
}

const retail = {
    setProfile,
    welcomeSequence,
    welcomeSequenceV2,
    order,
};

export default retail;
